import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { dateInKitchen } from './kitchenTime';
import type { Kitchen } from '../../libs';
import { mobileOnly } from '../BatchTracking/dashboardTokens';

/** The kitchen's date, with the page's action beside it. A plain paragraph: the heading order starts at the list below. */
const HomeHeader = ({ kitchen, now, children }: { kitchen: Kitchen; now: Date; children?: ReactNode }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, minHeight: 48 }}>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: 24,
          lineHeight: '32px',
          fontWeight: 600,
          letterSpacing: '-0.3px',
          color: 'neutral900',
          [mobileOnly]: { fontSize: 20, lineHeight: '28px' }
        }}
      >
        {dateInKitchen(kitchen, now)}
      </Typography>
    </Box>
    {children}
  </Box>
);

export default HomeHeader;
